// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"202":"f2f30228","326":"44985a82","344":"9d560302","463":"2614854c","538":"da087912","552":"e6f55190","588":"922859de","806":"e4cbbdd4","936":"e83ec323"}[chunkId] + ".chunk.js";
};